import React from 'react';
import { Link } from 'react-router-dom';
import OperationalDashboard from '../components/dashboard/OperationalDashboard';
import useAuth from '../hooks/useAuth';
import PendingInvitations from '../components/common/PendingInvitations';
import { ROLES, ROUTES } from '../utils/constants';
import './DashboardPage.css';

// The dashboard API only serves owners and admins (scoped to their organisations).
const DASHBOARD_ROLES = [ROLES.OWNER, ROLES.ADMIN];

const DashboardPage = () => {
  const { user, userRole } = useAuth();

  if (DASHBOARD_ROLES.includes(userRole)) {
    return (
      <div className="dashboard-page">
        <h1>Operational Dashboard</h1>
        <PendingInvitations />
        <OperationalDashboard />
      </div>
    );
  }

  return (
    <div className="dashboard-page">
      <h1>Welcome{user?.first_name ? `, ${user.first_name}` : ''}</h1>
      <PendingInvitations />
      {userRole === ROLES.APPLICANT ? (
        <>
          <p>
            Track your rental applications and manage your consents in{' '}
            <Link to={ROUTES.APPLICANT_PORTAL}>My Applications</Link>.
          </p>
          <p>
            Are you a landlord or agent? <Link to={ROUTES.GET_STARTED}>Set up to list properties</Link> and share an
            application link with applicants.
          </p>
        </>
      ) : (
        <p>Use the menu to open your work. Organisation metrics are visible to owners and administrators.</p>
      )}
    </div>
  );
};
export default DashboardPage;
